module.exports = "img{\r\n    max-width:100%;\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main